import axios, { AxiosError } from 'axios';
import { ENVS } from '@/config/env.config';
import { ERROR_CODE } from '@/constants/errors';
import { deleteAccount } from '@/redux';
import { dispatch } from '@/app/store';
import { camelCaseKeys } from './string.utils';

const TIMEOUT = 20000;
const instance = axios.create({
  timeout: TIMEOUT
});

const HEADERS = { 'Content-Type': 'application/json' };

export let accessToken = '';

instance.interceptors.request.use(
  (req: any) => {
    req.baseURL = `${ENVS.VITE_BASE_API}/`;
    let authen = {};
    if (accessToken) {
      authen = { Authorization: `Bearer ${accessToken}` };
    }

    req.headers = {
      ...HEADERS,
      ...req.headers,
      ...authen
    };
    return req;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res: any) => {
    const result = res?.data?.data || res?.data?.body?.response;
    const error = !res?.data?.success && res?.data?.statusCode !== 200;
    if (error) {
      if (res?.data?.body?.responseCode === 'UserNotFoundException' && accessToken) {
        dispatch(deleteAccount());
      }
      return Promise.reject(camelCaseKeys(result));
    }
    return Promise.resolve(result);
  },
  (axiosError: AxiosError) => {
    const { response: { data } = {} } = axiosError;
    if (axiosError && !axiosError?.response) {
      throw new Error('Send request API failed');
    }

    if (
      ((data as any).message === ERROR_CODE.Guard_MalformedJWT ||
        (data as any).message === 'jwt expired' ||
        (data as any).message === 'Invalid Token') &&
      accessToken
    ) {
      dispatch(deleteAccount());
    }

    const { message } = (data as any) || {};
    return Promise.reject(camelCaseKeys(message || axiosError));
  }
);

export const setAccessToken = (token: string) => {
  accessToken = token;
};

export default instance;
